import {
    ChangeDetectionStrategy,
    Component,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { UserService } from '../../user/user.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
    selector: 'fi-user-profile-link',
    templateUrl: './user-profile-link.component.html',
    styleUrls: ['./user-profile-link.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UserProfileLinkComponent implements OnChanges, OnDestroy {
    @Input() userId;
    @Input() userName;

    showAsLink = new BehaviorSubject<boolean>(false);

    constructor(
        private userService: UserService,
        private ngZone: NgZone,
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.userId) {
            this.checkAvailability();
        }
    }

    checkAvailability() {
        this.showAsLink.next(false);
        this.userService.checkUserAvailable(this.userId).then((result) => this.showAsLink.next(result.IsAvailable));
    }

    openUserProfileDialog() {
        this.userService.openUserViewDialog(this.userId);
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
